<div class="user-grid-container">
    <h4>Users</h4>
    <wj-flex-grid #grid (initialized)="onGridInitialized(grid)" [itemsSource]="userProfiles"
                  [showSelectedHeaders]="Wijmo.HeadersVisibility.All"
                  [showMarquee]="true" style="flex: 1"
                  [allowResizing]="Wijmo.AllowResizing.Columns" [autoRowHeights]="false" [quickAutoSize]="false"
                  [headersVisibility]="Wijmo.HeadersVisibility.Column" [selectionMode]="Wijmo.SelectionMode.Row" [isReadOnly]="true"
                  [autoGenerateColumns]="false"
                  (selectionChanged)="onSelectedUserChanged($event, grid)"
    >
        <wj-flex-grid-filter #gridFilter></wj-flex-grid-filter>
    </wj-flex-grid>
    <div class="toolbar-horizontal">
        <fluent-button appearance="primary" (click)="onRemoveUser()"><i class="far fa-remove"></i> Delete</fluent-button>
        <fluent-button appearance="primary" (click)="onToggleEnable()"><i class="far fa-check-circle"></i> En/Disable</fluent-button>
        <fluent-button appearance="primary" (click)="onCreateUser()"><i class="far fa-plus-circle"></i> New</fluent-button>
        <wj-flex-grid-search style="flex-grow: 1"
                             placeholder="Search for user(s)"
                             (keydown)="onSearchFieldKeyDown($event)"
                             [grid]="grid">
        </wj-flex-grid-search>
    </div>
</div>
<div style="flex: 1; height: 200px; padding-top: 10px">
    @if (userProfile()) {
        <h4>Permissions for {{userProfile()?.userName}}</h4>
        <app-admin-user-permissions [offices]="pfData.offices" [lobs]="pfData.lobs"
                                    [(appRoleAndPermissions)]="appRoleAndPermissions"
                                    (onApply)="this.savePermissions($event)"
        >

        </app-admin-user-permissions>
    }
</div>
